export default {
  host: window.location.port == '8090' ? 'http://liantiao.ainirobot.com:8070' : window.location.host.includes('open.ainirobot.com') ? 'https://api-open.ainirobot.com' : 'https://jp-api-open.ainirobot.com'
  // impFileHost: window.location.port == '8090' ? 'http://118.89.228.66:8090' : 'http://admin.ovs.ainirobot.com'
}



// WEBPACK FOOTER //
// ./src/config/production.js